import React from 'react';

class FullscreenText extends React.Component {
  constructor(props) {
    super(props);

  }

  render() {

    var item = this.props.item;

    return (!this.props.isDummy) ? (
      <div>
      <div className={'fullscreen-item-visible fullscreen-item loaded text-item'}
           style={{
             width: item.maxWidth + 'px',
             height: item.maxHeight + 'px',
             WebkitTransform: 'translate(-50%, -50%) scale(' + Math.round(100 * (item.width / item.maxWidth) * this.props.window.scale.min(item)) / 100 + ')',
             background: item.bgColor
           }}
           key={'text'}
           dangerouslySetInnerHTML={{__html: item.html}}
      ></div>
      </div>
    ) : <div/>;
  }
}

export default FullscreenText;


// WEBPACK FOOTER //
// ./components/fullscreen/fullscreenText.js